module.exports = __webpack_public_path__ + "static/media/-_Temporary Job.9e6cb349.png";